import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useLanguage } from "../contexts/LanguageContext.jsx";
import apiConfig from "../config/api.js";

const API_BASE = `${apiConfig.baseURL}/users`;
const INITIAL_FORM = {
  username: "",
  email: "",
  password: "",
  first_name: "",
  last_name: "",
  country: "",
};

/**
 * Hook pour la logique du formulaire d'authentification (connexion / inscription)
 */
export const useAuthPageForm = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isLogin, setIsLogin] = useState(true);

  useEffect(() => {
    if (searchParams.get("mode") === "register") {
      setIsLogin(false);
    }
  }, [searchParams]);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [formData, setFormData] = useState(INITIAL_FORM);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(null);

    try {
      const url = isLogin ? `${API_BASE}/login` : `${API_BASE}/register`;
      const requestData = isLogin
        ? { email: String(formData.email || "").trim(), password: formData.password }
        : formData;

      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      });

      if (response.ok) {
        const data = await response.json();
        localStorage.setItem("token", data.token);
        localStorage.setItem("user", JSON.stringify(data.data));
        setSuccess(
          isLogin
            ? t("loginSuccessRedirect")
            : t("registrationSuccessRedirect"),
        );

        window.dispatchEvent(
          new CustomEvent("authStateChanged", {
            detail: { user: data.data, token: data.token },
          }),
        );

        const targetPath = "/dashboard";
        setTimeout(() => navigate(targetPath, { replace: true }), 1000);
      } else {
        const errorData = await response.json();
        setError(errorData.message || t("errorAuthentication"));
      }
    } catch (err) {
      setError(t("connectionError"));
    } finally {
      setLoading(false);
    }
  };

  const toggleMode = () => {
    setIsLogin(!isLogin);
    setError(null);
    setSuccess(null);
    setFormData(INITIAL_FORM);
  };

  const openForgotPassword = () => setShowForgotPassword(true);
  const closeForgotPassword = () => setShowForgotPassword(false);

  return {
    isLogin,
    formData,
    loading,
    error,
    success,
    handleChange,
    handleSubmit,
    toggleMode,
    navigate,
    showForgotPassword,
    openForgotPassword,
    closeForgotPassword,
  };
};
